import { Loadstone, thinkingLoadstoneConfig, type LoadstoneConfig, type LoadstoneProps } from '@highlight/ui'

/** The blue `thinkingLoadstoneConfig` renders, so text beside it can match. */
export const STREAMING_CHAT_INDICATOR_BLUE = '#3A57C8'

const DARK_ORANGE = '#b45309'
const darkOrangeThinkingLoadstoneConfig = {
  ...thinkingLoadstoneConfig,
  cells: thinkingLoadstoneConfig.cells.map((cell) => ({
    ...cell,
    lightColor: DARK_ORANGE,
    darkColor: DARK_ORANGE,
  })),
} satisfies LoadstoneConfig

export interface StreamingChatIndicatorProps extends Omit<LoadstoneProps, 'config'> {
  tone?: 'blue' | 'dark-orange'
}

export function StreamingChatIndicator({ tone = 'blue', ...props }: StreamingChatIndicatorProps): JSX.Element {
  const config = tone === 'dark-orange' ? darkOrangeThinkingLoadstoneConfig : thinkingLoadstoneConfig

  return <Loadstone config={config} {...props} />
}
